import {
    TOPFEATURE_DELETE_START,
    TOPFEATURE_DELETE_SUCCESS,
    TOPFEATURE_DELETE_ERROR
} from "../../../constants";
import { deleteTopFeatureMutation as mutation, getAllHomePageCategorySettings as query } from "../../../lib/graphql";
import { setLoaderStart, setLoaderComplete } from "../../loader/loader";
import showToaster from "../../../helpers/toastrMessgaes/showToaster";

const deleteTopFeature = (id,) => {
    return async (dispatch, getState, { client }) => {

        try {
            dispatch({
                type: TOPFEATURE_DELETE_START
            });

            dispatch(setLoaderStart('DeleteTopFeature'));

            const { data } = await client.mutate({
                mutation,
                variables: { id },
                refetchQueries: [{ query }]
            })
            dispatch(setLoaderComplete('DeleteTopFeature'));

            if (data?.deleteTopFeature?.status == 200) {
                dispatch({
                    type: TOPFEATURE_DELETE_SUCCESS
                });
                showToaster({ messageId: 'deleteTopFeatureSuccess', toasterType: 'success' });
                return { status: 200 }
            } else {
                dispatch({
                    type: TOPFEATURE_DELETE_ERROR
                });
                showToaster({ messageId: 'errorMessage', requestContent: data?.deleteTopFeature?.errorMessage, toasterType: 'error' });
                return { status: 400 }
            }
        } catch (error) {
            dispatch({
                type: TOPFEATURE_DELETE_ERROR
            });
            showToaster({ messageId: 'errorMessage', requestContent: error, toasterType: 'error' });
            return { status: 400 }
        }
    }
}

export default deleteTopFeature;